// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Cell,
  Text,
  Legend,
} from 'recharts';

// Utilities
import { colors, truncateString } from 'common/utils/helpers';

// Components
import CustomTooltip from 'admin/engagement/reporting/components/CustomTooltip';

const tooltipAttributes = [
  { tooltipLabel: 'Percentage', payloadKey: 'percentage', percentage: true },
  { tooltipLabel: 'Count', payloadKey: 'count' },
];

const HorizontalBarReportChart = ({ data, compareInputs, chartRef }) => (
  <div className="numeric-report-chart">
    {/* eslint-disable react/no-array-index-key, react/prop-types */}
    <ResponsiveContainer width="100%" aspect={1.5}>
      <BarChart
        data={data}
        margin={{ top: 20, right: 30, left: 160, bottom: 20 }}
        layout="vertical"
        ref={chartRef}
      >
        {compareInputs && <Legend verticalAlign="top" />}
        <CartesianGrid horizontal={false} stroke="#e8e8e8" strokeWidth={1} />
        <Tooltip
          content={compareInputs ? null : <CustomTooltip attributes={tooltipAttributes} />}
          cursor={{ fill: 'rgba(100, 100, 100, 0.05)' }}
          isAnimationActive={false}
        />
        {compareInputs ? (
          compareInputs.map(({ id, labelTranslations: { en } }, index) => (
            <Bar
              key={id}
              dataKey={`${en} Percentage`}
              name={en}
              barSize={20}
              fill={colors[index]}
              unit="%"
              stackId="meow" // needs a random string as ID
              isAnimationActive={false}
            />
          ))
        ) : (
          <Bar
            dataKey="percentage"
            name="Percentage"
            background={{ fill: '#d6d6d6' }}
            barSize={20}
            unit="%"
            isAnimationActive={false}
          >
            {data.map((entry, index) => (
              <Cell key={index} fill={entry.top ? '#5b7d12' : '#4a90e2'} />
            ))}
          </Bar>
        )}
        <YAxis
          type="category"
          dataKey="label"
          tickLine={false}
          tick={(props) => (
            <Text {...props} width={props.width / data.length + 400} fontSize={14}>
              {truncateString(props.payload.value, 30)}
            </Text>
          )}
          stroke="#636363"
          strokeWidth={1}
          interval={0}
        />
        <XAxis
          type="number"
          domain={[0, 100]}
          ticks={[0, 25, 50, 75, 100]}
          tickLine={false}
          unit="%"
          interval={0}
          axisLine={false}
        />
      </BarChart>
    </ResponsiveContainer>
    {/* eslint-enable react/no-array-index-key, react/prop-types */}
  </div>
);

HorizontalBarReportChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      percentage: PropTypes.number,
      top: PropTypes.bool,
    })
  ).isRequired,
  compareInputs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      label_translations: PropTypes.objectOf(PropTypes.string),
    })
  ),
  chartRef: PropTypes.shape({
    current: PropTypes.elementType,
  }).isRequired,
};

HorizontalBarReportChart.defaultProps = {
  compareInputs: null,
};

export default HorizontalBarReportChart;
